'use es6';

import { combineReducers } from 'redux';
import auth from './auth';
import appIntegrations from './appIntegrations';
import details from './details';
import requestStates from './requestStates';
import notifications from 'ReduxMessenger/reducers/Notifications';
import trackingParams from './trackingParams';
import users from './users';
export default combineReducers({
  auth,
  appIntegrations,
  details,
  notifications,
  requestStates,
  trackingParams,
  users
});